import React from 'react';
import ReactDOM from 'react-dom';
import App from './example/App';

ReactDOM.render(<App />, document.getElementById('root'));
